import React, { ReactNode, useCallback, useState } from "react";
import { animated, config, Transition } from "react-spring";
import { breakpoints } from "src/styles/createBreakpoints";
import { getViewportWidth } from "src/utils/browser";
import { VehicleState } from "Types/state";
import useEventListener from "src/utils/useEventListener";

export interface VehiclesListProps {
    children: (vehicle: VehicleState, index: number) => ReactNode;
    items: VehicleState[];
}
const getWidth = () => (getViewportWidth() <= breakpoints.sm - 1 ? 130 : 220);

const VehiclesList = ({ children, items }: VehiclesListProps) => {
    // Handles resizing columns
    const [itemWidth, setItemWidth] = useState(() => getWidth());
    const setWidth = useCallback(() => setItemWidth(getWidth()), []);
    useEventListener("resize", setWidth);

    return (
        <ul
            className={"TableCompare__vehicles"}
            style={{
                height: "100%",
                position: "relative",
            }}
        >
            <Transition
                native
                items={items.map((vehicle: VehicleState, index: number) => ({
                    key: (vehicle && vehicle.vin) || `${index}_`,
                    vehicle,
                    x: itemWidth * index,
                }))}
                keys={(item) => item.key}
                initial={null}
                from={{ opacity: 0, scale: 1 }}
                leave={{ opacity: -3 }}
                enter={({ x }) => ({ x, opacity: 3 })}
                update={({ x }) => ({ x, scale: 1, opacity: 1 })}
                config={config.slow}
                trail={100}
            >
                {({ vehicle }, s, i) => ({ x, opacity }: any) => (
                    <animated.li
                        className={`TableCompare__vehicle-container ${
                            vehicle?.gone ? "TableCompare__vehicle-disabled" : ""
                        }`}
                        style={{
                            position: "absolute",
                            willChange: "transform, opacity",
                            opacity,
                            transform: x.interpolate((X: number) => `translate3d(${X}px,0, 0)`),
                            zIndex: 550 - i,
                        }}
                        children={children(vehicle, i)}
                    />
                )}
            </Transition>
        </ul>
    );
};

export default VehiclesList;
